/**
 * @module tizen/userManager
 * @private
 */

import { services } from "../../../constants";

const VOUCHER_QUANTITY = 1;
const APP_TYPE = "tv_app";
const ELIGIBILITY_CAMPAIGN = "samsung_tv";
const APP_ID = "3201511006673";

/**
 * Creates request body object to be sent in voucher eligibility request.
 */
async function createVoucherEligibilityRequestBody() {
  return {
    voucher_order: {
      quantity: VOUCHER_QUANTITY,
      app_type: APP_TYPE,
      eligibility_campaign: ELIGIBILITY_CAMPAIGN,
      eligibility_attributes: {
        duid: (await this.systemManager.device.getId()) || "",
        model_id: (await this.systemManager.device.getModelCode()) || "",
        app_id: APP_ID,
        mac_address: await this.systemManager.network.getMac(),
        real_model: await this.systemManager.device.getRealModel()
      }
    }
  };
}
/**
 * Checks user's device voucher eligibility.
 */
export async function checkVoucherEligiblity() {
  try {
    const response = await this.http.post(
      `${this.backendHosts.settings}${services.voucherEligibility}`,
      await createVoucherEligibilityRequestBody.call(this)
    );
    return response.data;
  } catch (error) {
    throw new Error(`Couldn't retrieve voucher eligibility information -> ${error}`);
  }
}
